const routes = [
  {
    path: '',
    component: () => import('@/views/provider/reinbursement/Wrapper.vue'),
    children: [
      {
        path: '/provider/reimbursement',
        name: 'Reimbursement',
        component: () => import('@/views/provider/reinbursement/Main.vue'),
      },
      {
        path: '/provider/reimbursement/detail/:requestId',
        name: 'ReimbursementDetail',
        component: () =>
          import('@/views/provider/reinbursement/ReinbursementDetail.vue'),
      },
      {
        path:
          '/provider/reimbursement/new/:tapRequestId/:institutionId/:academicYearId/:ssn/:requestTypeId/:tapRequestNumber',
        name: 'NewReimbursement',
        component: () =>
          import('@/views/provider/reinbursement/ReinbursementDetail.vue'),
      },
      {
        path: '/provider/reimbursement/AIValidation/:requestId',
        name: 'AIReinbursementValidation',
        component: () =>
          import('@/views/provider/reinbursement/AIValidation.vue'),
      },
    ],
  },
];

export default routes;
